import {inject, Injectable} from '@angular/core';
import {LoadingController} from '@ionic/angular/standalone';
import {TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingSpinnerService {
    private translateService: TranslateService = inject(TranslateService);
    private loadingController: LoadingController = inject(LoadingController)
    private loadingSpinner?: HTMLIonLoadingElement;

    constructor() {
    }

    public async showSpinner(messageKey?: string) {
        if (!this.loadingSpinner) {
            const loadingMessage = await firstValueFrom(this.translateService.get(messageKey ?? "components.errorOverview.loadingData"));
            this.loadingSpinner = await this.loadingController.create({
                message: loadingMessage
            });

            await this.loadingSpinner.present();
        }
    }

    public async hideSpinner() {
        await this.loadingSpinner?.dismiss();
        this.loadingSpinner = undefined;
    }
}
